
import { Component, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { moneyFormat } from "@/utils/util";
import DimensionSelect from "@/components/DimensionSelect/index.vue";
import SearchPopup from "./../components/SearchPopup.vue";
import { getReportRecharge, getReportRechargeTotal } from "@/api/shouyin";

@Component({
  components: { DimensionSelect, SearchPopup },
})
export class StoredValueDetails extends Vue {
  @Getter companyId!: string;
  params = {};

  dimension = "总览";
  dimensionValue = "";

  searchRes = null;

  moneyFormat = moneyFormat;
  grid = [
    {
      label: "储值金额",
      value: 0,
      prop: "totalTopUpMoney",
      isMoney: true,
    },
    {
      label: "储值笔数",
      value: 0,
      prop: "totalTopUpCount",
      isMoney: false,
    },
  ];

  listData = [];
  refreshing = false;
  loading = false;
  finished = true;
  error = false;
  pagination = {
    total: 0,
    pageIndex: 1,
    pageSize: 10,
  };

  @Watch("params")
  onParamsChange() {
    // 获取数据
    this.getData();
  }

  // 下拉刷新
  onRefresh() {
    this.pagination.pageIndex = 1;
    this.refreshing = true;
    this.getListData();
  }

  // 上拉加载更多
  onLoad() {
    this.pagination.pageIndex++;
    this.getListData();
  }

  onDimensionConfirm(name: string, value: string) {
    this.dimension = name;
    this.dimensionValue = value;
    this.params = {
      ...this.params,
      orderType: value,
    };
  }

  onSearchConfirm(res) {
    this.searchRes = res;
    const { starttime, endtime } = res;
    this.params = {
      ...this.params,
      queryTimeBegin: `${starttime} 00:00:00`,
      queryTimeEnd: `${endtime} 23:59:59`,
      orderType: this.dimensionValue,
      storeId: this.companyId,
    };
  }

  getData() {
    this.getTotalData();
    this.onRefresh();
  }

  getTotalData() {
    getReportRechargeTotal(this.params).then((res) => {
      this.grid.forEach((item) => {
        item.value = res.data[item.prop];
      });
    });
  }

  getListData() {
    return getReportRecharge({
      ...this.params,
      pageIndex: this.pagination.pageIndex,
      pageSize: this.pagination.pageSize,
    })
      .then((res) => {
        if (this.refreshing) {
          this.listData = [];
        }
        this.listData = this.listData.concat(res.data.records);
        if (this.pagination.pageIndex >= res.data.totalPages) {
          this.finished = true;
        } else {
          this.finished = false;
        }
        this.refreshing = false;
      })
      .catch(() => {
        this.finished = true;
      })
      .finally(() => {
        this.loading = false;
      });
  }
}
export default StoredValueDetails;
